import { render, staticRenderFns } from "./manage-fields.html?vue&type=template&id=01b549b5&scoped=true&external"
import script from "./manage-fields.js?vue&type=script&lang=js&external"
export * from "./manage-fields.js?vue&type=script&lang=js&external"
import style0 from "./manage-fields.scss?vue&type=style&index=0&id=01b549b5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b549b5",
  null
  
)

export default component.exports